import type { ReactNode } from "react";
import { useI18n } from "../i18n/I18nProvider";

interface Props {
  titleKey: string;
  subtitleKey?: string;
  children?: ReactNode;
}

// Renders the standard page header. The title strings often contain an inline
// <em> tag for typographic emphasis, so we render via dangerouslySetInnerHTML
// — content comes from our own bundled strings file, not user input.
export function PageHeader({ titleKey, subtitleKey, children }: Props) {
  const { tHtml, t } = useI18n();
  return (
    <div className="page-header">
      <div>
        <div className="page-title" dangerouslySetInnerHTML={{ __html: tHtml(titleKey) }} />
        {subtitleKey && <div className="page-subtitle">{t(subtitleKey)}</div>}
      </div>
      {children}
    </div>
  );
}
